import type { LoaderFunctionArgs } from "@remix-run/node";
import { json, redirect } from "@remix-run/node";
import { Form, useLoaderData } from "@remix-run/react";

import { login } from "../../shopify.server";

import styles from "./styles.module.css";

// export const loader = async ({ request }: LoaderFunctionArgs) => {
//   const url = new URL(request.url);

//   if (url.searchParams.get("shop")) {
//     throw redirect(`/app?${url.searchParams.toString()}`);
//   }

//   return json({ showForm: Boolean(login) });
// };

export default function App() {
  // const { showForm } = useLoaderData<typeof loader>();

  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <h1 className={styles.heading}>AI Metafields Privacy Policy</h1>
        <p>Welcome to AI Metafields. We are committed to protecting and respecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Shopify app. Please read this policy carefully.</p>

        <h2>1. Information We Collect</h2>
        <p>We collect the following types of personal data:</p>
        <ul>
            <li><strong>Store Information:</strong> Including location, name, and unique identifiers.</li>
            <li><strong>Product Information and Metadata:</strong> Including descriptions, images, metadata, and prices.</li>
            <li><strong>App Usage Analytics Data:</strong> Including IP address, location, and cohort data.</li>
        </ul>

        <h2>2. How We Collect Data</h2>
        <p>Data is collected automatically through our app's functionalities.</p>

        <h2>3. Use of Data</h2>
        <p>We use the collected data for the following purposes:</p>
        <ul>
            <li><strong>Customer Support:</strong> To assist with inquiries and resolve issues.</li>
            <li><strong>Product Analytics:</strong> To analyze usage patterns and improve our services.</li>
        </ul>

        <h2>4. Data Sharing</h2>
        <p>We share specific product and collection metadata with ChatGPT to generate requested content.</p>

        <h2>5. Data Access and Deletion</h2>
        <p>Users can uninstall the app to automatically purge their data. For subject access requests or other data-related inquiries, please email us at <a href="mailto:support@aimetafields.com">support@aimetafields.com</a>.</p>

        <h2>6. Data Storage and Retention</h2>
        <p>Data is stored on servers hosted in the EU. We retain information throughout the lifetime of the account and for up to 6 years afterwards.</p>

        <h2>7. Security Measures</h2>
        <p>We implement robust security measures including:</p>
        <ul>
            <li><strong>256-bit SSL Encryption</strong></li>
            <li><strong>Regular Security Audits</strong></li>
            <li><strong>Separation of Database and Code</strong></li>
        </ul>

        <h2>8. Cookies and Tracking Technologies</h2>
        <p>We use Google Analytics, which sets cookies for tracking and analyzing user behavior.</p>

        <h2>9. Third-Party Services and Data Transfers</h2>
        <p>We use Shopify as a third-party service provider. Data is transferred outside the UK or EEA only as necessary, and we ensure protection through appropriate safeguards.</p>

        <h2>10. Age Restrictions</h2>
        <p>Our app is not intended for individuals under 18 years of age.</p>

        <h2>11. Contact Information</h2>
        <p>For privacy-related inquiries, please contact us at:</p>
        <p>Email: <a href="mailto:support@aimetafields.com">support@aimetafields.com</a></p>

        <h2>12. Changes to This Privacy Policy</h2>
        <p>We will notify users of any changes to this Privacy Policy via email.</p>

        <h2>13. Effective Date</h2>
        <p>This Privacy Policy is effective as of 23rd August 2024.</p>
      </div>
    </div>
  );
}